<template>
  <div id="app">
    <v-col cols="12" v-if="informText != ''">
      <v-alert type="error">
        {{ this.informText }}
      </v-alert>
    </v-col>
    <table width="100%">
      <tr>
        <td>Current Password</td>
        <td>
          <input
            type="password"
            class="form-control"
            style="margin-top: 5px"
            v-model="currentPass"
          />
        </td>
      </tr>
      <tr>
        <td>New Password</td>
        <td>
          <input
            type="password"
            class="form-control"
            style="margin-top: 5px"
            v-model="newPass"
          />
        </td>
      </tr>
      <tr>
        <td>Re-Enter Password</td>
        <td>
          <input
            type="password"
            class="form-control"
            style="margin-top: 5px"
            v-model="reEnterPass"
          />
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <b style="color: red">
            Password phải có 12 ký tự trở lên,<br />
            bao gồm chữ viết HOA và chữ viết thường</b
          >
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <v-btn
            color="success"
            style="margin-top: 5px"
            @click="changeCurrentUserPassword"
            >Accept</v-btn
          >&nbsp;
          <v-btn
            class="orange"
            style="margin-top: 5px"
            @click="cancelDialog"
            dark
            >Cancel</v-btn
          >
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "SiteCreate",
  data() {
    return {
      currentPass: "",
      newPass: "",
      reEnterPass: "",
      informText: "",
    };
  },
  methods: {
    async changeCurrentUserPassword() {
      if (this.newPass == this.reEnterPass) {
        try {
          const user = await Auth.currentAuthenticatedUser({
            bypassCache: false,
          });

          const changePasswordResult = await Auth.changePassword(
            user,
            this.currentPass,
            this.newPass
          );

          if (changePasswordResult == "SUCCESS") {
            this.$root.$refs.Dialog.handleBackdropClick();
          }
        } catch (error) {
          console.log("changeCurrentUserPassword: ", error);
          this.informText = error.message;
          //console.log('this.informText: ',this.informText)
        }
      }
    },

    cancelDialog() {
      this.$root.$refs.profile.turnOffDialog();
    },
  },
};
</script>

<style scoped>
</style>